import useTheme from 'chat-ui/src/hooks/useTheme';
import { useNavigate } from 'react-router-dom';
import TelletLogo from '@/assets/logo/tellet-logo-main.svg';
import EmpathyLogo from '@/assets/logo/empathy-logo-black.svg';
import Illustration from '@/assets/illustrations/invitation-expired.svg';
import Image from '@/components/atoms/Image';
import { ECompanyThemeName } from '@/enums';
import Routes from '@/router/routes';
import { Button } from '@/components/ui/button';

const themeLogosList = {
  [ECompanyThemeName.DEFAULT]: (
    <Image src={TelletLogo} alt="logo" className="absolute w-24 h-fit top-6 left-5" />
  ),
  [ECompanyThemeName.EMPATHY]: (
    <Image src={EmpathyLogo} alt="logo" className="absolute w-44 h-fit top-6 left-5" />
  ),
};

function SessionExpired() {
  const { themeName } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="relative flex items-center justify-center min-h-screen px-4 mx-auto text-center">
      {themeLogosList[themeName]}
      <div className="flex flex-col items-center justify-center gap-2 mx-auto text-center">
        <Image
          effect="blur"
          src={Illustration}
          alt="illustration"
          className="min500:w-full w-[450px]"
        />
        <h1 className="text-5xl font-bold mt-14 text-dark min500:text-4xl">Session expired.</h1>
        <p className="mt-2 mb-4 text-lg font-semibold">Please log in again to continue </p>
        <Button onClick={() => navigate(Routes.login.path)}>Go to Login</Button>
      </div>
    </div>
  );
}

export default SessionExpired;
